import React, { useEffect, useState } from 'react';
import { Text, Switch } from '@radix-ui/themes';

const RpCompletePreparation = ({ onDone, setFileUrl, activePresentation }) => {
  const [prepOption, setPrepOption] = useState('');
  const [file, setFile] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setError('');
  }, [prepOption, file]);

  const handleDone = () => {
    if (prepOption === 'case_url' && !file) {
      setError('Please select document to upload!');
      return;
    }
    onDone();
  };

  const uploadDocument = async (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    // Simulate uploadFileonS3 with a fetch call
    try {
      const formData = new FormData();
      formData.append('file', selectedFile);
      const response = await fetch('YOUR_S3_UPLOAD_ENDPOINT', { // Replace with actual S3 upload endpoint
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      const url = data?.body?.postResponse?.location; // Adjust based on actual response structure
      setFileUrl(url);
      setFile(url);
    } catch (error) {
      console.error('Unable to upload document due to:', error);
    }
  };

  return (
    <div className="flex flex-1 justify-center items-center">
      <Text
        as="span"
        size="4"
        className="text-white py-[1.5vh] font-[Lato-Regular] text-center w-[40vw] mt-[2vh]"
      >
        Complete preparation for your presentation
      </Text>

      <div className="flex items-center my-[1vh]">
        <Text
          as="span"
          size="3"
          className="text-white font-[Lato-Regular] w-[40vw]"
        >
          Share Screen
        </Text>
        <Switch
          color="green"
          onCheckedChange={(shareScreen) => {
            if (!shareScreen) {
              setPrepOption('');
              activePresentation('');
            } else {
              setPrepOption('share_screen');
              activePresentation('share_screen');
            }
          }}
          checked={prepOption === 'share_screen'}
        />
      </div>
      <div className="flex items-center my-[1vh]">
        <Text
          as="span"
          size="3"
          className="text-white font-[Lato-Regular] w-[40vw]"
        >
          Share Whiteboard
        </Text>
        <Switch
          color="green"
          onCheckedChange={(shareWhiteboard) => {
            if (!shareWhiteboard) {
              setPrepOption('');
              activePresentation('');
            } else {
              setPrepOption('share_whiteboard');
              activePresentation('share_whiteboard');
            }
          }}
          checked={prepOption === 'share_whiteboard'}
        />
      </div>
      <div>
        <div className="flex items-center my-[1vh]">
          <Text
            as="span"
            size="3"
            className="text-white font-[Lato-Regular] w-[40vw]"
          >
            Attach Document/ media to present
          </Text>
          <Switch
            color="green"
            onCheckedChange={(attachMedia) => {
              if (!attachMedia) {
                setPrepOption('');
                activePresentation('');
              } else {
                setPrepOption('case_url');
                activePresentation('case_url');
              }
            }}
            checked={prepOption === 'case_url'}
          />
        </div>
        {prepOption === 'case_url' && (
          <button
            className="p-[2vw] rounded-[2vw] border border-white self-start mb-[1vh]"
          >
            <label htmlFor="file-upload" className="cursor-pointer">
              <Text
                as="span"
                size="3"
                className="text-white font-[Lato-Regular]"
              >
                Upload Document
              </Text>
            </label>
            <input
              id="file-upload"
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={uploadDocument}
              className="hidden"
            />
          </button>
        )}
      </div>
      {error && (
        <Text
          as="span"
          size="3"
          className="text-red-500 font-[Lato-Regular]"
        >
          {error}
        </Text>
      )}
      <button
        onClick={handleDone}
        className="bg-[#43A047] rounded-[2vw] py-[1.2vh] px-[7vw] mb-[1vh] shadow-md"
      >
        <Text
          as="span"
          size="3"
          className="text-white font-[Lato-Regular]"
        >
          Done
        </Text>
      </button>
    </div>
  );
};

export default RpCompletePreparation;